import React, { useCallback, useEffect, useState } from 'react';
import { Table, Alert, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faPlus, faMinusCircle, faEdit, faTrash, faSearch, faBroom, faFilter } from '@fortawesome/free-solid-svg-icons';
import ActionIcon from 'src/components/general/ActionIcon';
import { formatterPeso } from 'src/utils/utils';
import { getRecruitmentMethodsData } from 'src/redux/wageTemplate/wageTemplateReducer';
import { useDispatch, useSelector } from 'react-redux';
import { tryGetRecruitmentMethod } from 'src/redux/wageTemplate/wageTemplateActionCreator';

const PayrollTable = ({
    records,
    isFetching,
    mode = 'LIST', // LIST, SELECT, ASSOCIATE
    onSelect,
    onAssociate,
    onDetail,
    onEdit,
    onDelete,
    selectedItems,
    associatedItems,
    filters = {},
    onFilterChange,
    onClearFilters,
    onApplyFilters
}) => {

    const dispatch = useDispatch();
    const [localFilters, setLocalFilters] = useState({ ...filters });
    const recruitmentMethods = useSelector(state => getRecruitmentMethodsData(state));

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setLocalFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleApplyFilters = () => {
        if (onFilterChange) {
            onFilterChange(localFilters);
        }
        if (onApplyFilters) {
            onApplyFilters();
        }
    };

    const handleClearFilters = () => {
        const emptyFilters = {
            id: '',
            wageLiquidationType: '',
            name: '',
            description: '',
            netAmount: '',
            generalAmount: '',
        };
        setLocalFilters(emptyFilters);
        if (onClearFilters) {
            onClearFilters();
        }
    };

    useEffect(() => {
        // setLocalFilters({ ...filters });

        // Comparar si los filtros han cambiado realmente
        const filtersChanged = Object.keys(filters).some(key => filters[key] !== localFilters[key]);
        if (filtersChanged) {
            setLocalFilters({ ...filters });
        }
    }, [filters]);

    useEffect(() => {
        dispatch(tryGetRecruitmentMethod());
    }, []);

    const renderActions = (item) => {
        if (mode === 'SELECT') {
            const isSelected = selectedItems?.some(selected => selected.id === item.id);
            return (
                <ActionIcon
                    size='lg'
                    className={'mx-2'}
                    toolTipText={(isSelected ? 'Quitar liquidación' : 'Agregar liquidación')}
                    icon={isSelected ? faMinusCircle : faPlus}
                    onClick={() => onSelect(item)}
                />
            );
        }

        if (mode === 'ASSOCIATE') {
            const isAssociated = associatedItems?.some(associated => associated.id === item.id);
            return (
                <div className='d-flex justify-content-center'>
                    <Form.Check
                        type='checkbox'
                        checked={isAssociated}
                        onChange={() => onAssociate(item)}
                        title={isAssociated ? 'Desasociar liquidación' : 'Asociar liquidación'}
                    />
                </div>
            );
        }

        return (
            <>
                <ActionIcon
                    size='lg'
                    className={'mx-2'}
                    toolTipText='Detalle de liquidación'
                    icon={faSearch}
                    onClick={() => onDetail(item)}
                />
                {(item.state !== 'ANULADO' && item.state !== 'ACTIVO') && (
                    <>
                        <ActionIcon
                            size='lg'
                            className={'mx-2'}
                            toolTipText='Editar liquidación'
                            icon={faEdit}
                            onClick={() => onEdit(item)}
                        />
                        <ActionIcon
                            size="lg"
                            className={'mx-2'}
                            toolTipText='Anular liquidación'
                            icon={faTrash}
                            onClick={() => onDelete(item)}
                        />
                    </>
                )}
            </>
        );
    };

    return (
        <Table striped hover size='sm'>
            <thead>
                <tr>
                    <th className='text-center align-middle' width='10%'>Número</th>
                    <th className='text-center align-middle' width='10%'>Método de contratación</th>
                    <th className='text-center align-middle' width='15%'>Nombre</th>
                    <th className='text-center align-middle' width='30%'>Descripcion</th>
                    <th className='text-center align-middle' width='10%'>Importe líquido</th>
                    <th className='text-center align-middle' width='15%'>Total general</th>
                    <th className='text-center align-middle' width='10%'>Acciones</th>
                </tr>
                {mode === 'SELECT' &&
                    <tr>
                        <th>
                            <Form.Control
                                name="id"
                                placeholder="Filtrar..."
                                size="sm"
                                value={localFilters.id || ''}
                                onChange={handleFilterChange}
                            />
                        </th>
                        <th>
                            <Form.Control
                                as="select"
                                name="wageLiquidationType"
                                size="sm"
                                value={localFilters.wageLiquidationType || ''}
                                onChange={handleFilterChange}
                            >
                                <option value="">Seleccionar...</option>
                                {Array.isArray(recruitmentMethods) ?
                                    recruitmentMethods.map((method, idx) => (
                                        <option value={method} key={idx}>
                                            {method.replace(/_/g, ' ')}
                                        </option>
                                    )) :
                                    <option value="">No hay métodos disponibles</option>
                                }
                            </Form.Control>
                        </th>
                        <th>
                            <Form.Control
                                name="name"
                                placeholder="Filtrar..."
                                size="sm"
                                value={localFilters.name || ''}
                                onChange={handleFilterChange}
                            />
                        </th>
                        <th>
                            <Form.Control
                                name="description"
                                placeholder="Filtrar..."
                                size="sm"
                                value={localFilters.description || ''}
                                onChange={handleFilterChange}
                            />
                        </th>
                        <th>
                            <Form.Control
                                name="netAmount"
                                placeholder="Filtrar..."
                                size="sm"
                                value={localFilters.netAmount || ''}
                                onChange={handleFilterChange}
                            />
                        </th>
                        <th>
                            <Form.Control
                                name="generalAmount"
                                placeholder="Filtrar..."
                                size="sm"
                                value={localFilters.generalAmount || ''}
                                onChange={handleFilterChange}
                            />
                        </th>
                        <th>
                            <div className='d-flex justify-content-around'>
                                <ActionIcon
                                    size="lg"
                                    id="search-button"
                                    className="btn-primary search-button text-white-color"
                                    toolTipText="Filtrar"
                                    icon={faFilter}
                                    onClick={handleApplyFilters}
                                />
                                <ActionIcon
                                    size="lg"
                                    className="btn-primary clean-filter text-white-color mr-2"
                                    toolTipText="Limpiar filtros"
                                    icon={faBroom}
                                    onClick={handleClearFilters}
                                />
                            </div>
                        </th>
                    </tr>}
            </thead>
            <tbody className='text-black-color'>
                {records?.length > 0 ? (
                    records.map(item => (
                        <tr key={item?.id} className={item?.state === 'ANULADO' ? 'text-danger' : ''}>
                            <td className='text-center align-middle truncate maxTruncate'>
                                {item?.id}
                            </td>
                            <td className='text-center align-middle truncate maxTruncate'>
                                {item?.wageLiquidationType?.replace(/_/g, ' ')}
                            </td>
                            <td className='text-center align-middle truncate maxTruncate'>
                                {item?.name}
                            </td>
                            <td className='text-center align-middle truncate maxTruncate'>
                                {item?.description}
                            </td>
                            <td className='text-center align-middle truncate maxTruncate'>
                                {formatterPeso.format(item?.netAmount)}
                            </td>
                            <td className='text-center align-middle truncate maxTruncate'>
                                {formatterPeso.format(item?.generalAmount)}
                            </td>
                            <td className='text-center align-middle p-0'>
                                {renderActions(item)}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={7} className='text-center'>
                            {!isFetching && (
                                <Alert variant='info' className='mb-0'>
                                    <FontAwesomeIcon icon={faExclamationTriangle} className='text-black-color mr-3' />
                                    No hay Liquidaciones de Haberes o no se posee permiso de acceso a las mismas.
                                </Alert>
                            )}
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default PayrollTable;